import { createContext, forwardRef, useContext, useMemo } from 'react';

import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';

import { toggleVariants } from '@/components/Toggle';
import { cn } from '@/utils';

const ToggleGroupContext = createContext({
	size: 'default',
	variant: 'default'
});

const ToggleGroup = forwardRef(
	({ className, variant, size, children, ...props }, ref) => {
		const contextValue = useMemo(() => ({ variant, size }), [variant, size]);

		return (
			<ToggleGroupPrimitive.Root
				ref={ref}
				className={cn('flex items-center justify-center gap-2', className)}
				{...props}
			>
				<ToggleGroupContext.Provider value={contextValue}>
					{children}
				</ToggleGroupContext.Provider>
			</ToggleGroupPrimitive.Root>
		);
	}
);

ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;

const ToggleGroupItem = forwardRef(
	({ className, children, variant, size, ...props }, ref) => {
		const context = useContext(ToggleGroupContext);

		return (
			<ToggleGroupPrimitive.Item
				ref={ref}
				className={cn(
					toggleVariants({
						variant: context.variant || variant,
						size: context.size || size
					}),
					className
				)}
				{...props}
			>
				{children}
			</ToggleGroupPrimitive.Item>
		);
	}
);

ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;

export { ToggleGroup, ToggleGroupItem };
